import { render, staticRenderFns } from "./cambioContrasenia.vue?vue&type=template&id=f3529e86&scoped=true"
import script from "./cambioContrasenia.vue?vue&type=script&lang=js"
export * from "./cambioContrasenia.vue?vue&type=script&lang=js"
import style0 from "./cambioContrasenia.vue?vue&type=style&index=0&id=f3529e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3529e86",
  null
  
)

export default component.exports